/**
 * PreviewEnvBanner — global indicator that the user is on the preview build
 * (not drawready.com production). Shows a thin amber strip at the very top of
 * every page so it's impossible to confuse the two environments.
 *
 * Detection: window.location.hostname contains "preview" but is not drawready.com.
 * In production the component renders null.
 */
import React from 'react';

export default function PreviewEnvBanner() {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname || '';
  const isPreview = host.includes('preview') && !host.includes('drawready.com');
  if (!isPreview) return null;
  return (
    <div
      className="bg-amber-500 text-white text-[11px] font-semibold tracking-wide text-center py-1 px-3 shadow-sm"
      data-testid="preview-env-banner"
      role="status"
    >
      PREVIEW BUILD · outgoing emails are rerouted to your admin inbox · not the live drawready.com app
    </div>
  );
}
